<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Pedidos</h4>
            <div class="small text-muted">Administración de todos los pedidos ingresados al sistema</div>
          </b-col>
                  <b-col cols="auto" class="d-flex align-items-center">
            <WidgetVisibilityConfig
              :widgets="widgetsMeta"
              :hidden="hiddenWidgets"
              :disabled="!visibilityLoaded"
              :locked="editingLocked"
              @toggle="onToggleWidget"
              @reset="resetWidgetsVisibility"
              @toggle-lock="setEditingLocked($event)"
            />
            <ChangelogWidget moduleKey="orders" :limit="5" />
          </b-col>
</b-row>
      </b-card>

      <b-row>
        <b-col lg="9">
                  <WidgetMasonry
                    v-if="visibilityLoaded"
                    v-model="widgetsOrdered"
                    :disabled="!visibilityLoaded || editingLocked"
                    @order-end="saveWidgetOrder"
                    @resize-end="commitWidgetSize"
                  >
                    <template v-slot:default="{ item }">
                        <Widget
                          :configWidget="configWidget"
                          :reference="item.reference"
                          :hasAccess="item.hasAccess"
                          :allowHide="!editingLocked"
                          :allowDrag="!editingLocked"
                          :allowResize="!editingLocked"
                          @hide-widget="hideWidget"
                        />
                    </template>
                  </WidgetMasonry>
        </b-col>  
        <b-col lg="3">
        
          <b-list-group class="mb-1" v-if="isProducts && !isSeller && configSubView.elements.order">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openOrders()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Pedidos</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Crear y administrar todos los pedidos emitidos y recibidos                
              </p>
            </b-list-group-item>
          </b-list-group>       

          <b-list-group class="mb-1" v-if="isProducts && isSeller && configSubView.elements.order_sellers">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openOrdersSellers()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">
                  <i class="fa fa-plus mr-2"></i>
                  Mis Pedidos
                </h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de todos mis pedidos emitidos y recibidos
              </p>
            </b-list-group-item>
          </b-list-group>

          <b-list-group class="mb-1" v-if="isProducts && isSeller && configSubView.elements.mobile_order_create">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openMobileOrderCreate()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">
                  <i class="fa fa-mobile mr-2"></i>
                  Crear Pedido
                </h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Vista optimizada para dispositivos móviles
              </p>
            </b-list-group-item>
          </b-list-group>

          <b-list-group class="mb-1" v-if="isCourses && !isSeller && configSubView.elements.order_courses">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openOrderCourses()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Ventas de Cursos</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de todos las ventas de cursos recibidas
              </p>
            </b-list-group-item>
          </b-list-group>  

          <b-list-group class="mb-1" v-if="parameters.haveReason && !isSeller && configSubView.elements.order_reason">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openOrdersReason()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Motivos</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Motivos de pedidos
              </p>
            </b-list-group-item>
          </b-list-group>

          <b-list-group class="mb-1" v-if="!isSeller && configSubView.elements.configuration">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openConfiguration()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Configuración</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Configuracón del módulo
              </p>
            </b-list-group-item>
          </b-list-group>
                  
          <hr v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
          <b-list-group class="mt-2" v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
            <b-list-group-item v-for="item in arr.PHPCustom" :key="item.id" href="#" class="flex-column align-items-start" @click="openPHPCustom(item)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                {{item.observations}}
              </p>
            </b-list-group-item>
          </b-list-group>          
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import WidgetVisibilityConfig from '@/components/inc/widget/WidgetVisibilityConfig'
  import WidgetMasonry from '@/components/inc/widget/WidgetMasonry'
  import DashboardWidgetsHelper from '@/components/inc/widget/DashboardWidgetsHelper'
import ChangelogWidget from '@/components/inc/changelog/ChangelogWidget'
  import Param from '@/config/parameters'
  import ServicesPHP from '@/components/modules/users/php/staff/services'

  export default {
    mixins: [DashboardWidgetsHelper],
    components: {
      Widget,
      WidgetVisibilityConfig,
      WidgetMasonry,
      ChangelogWidget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PEDIDOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.PEDIDOS,
          profile_id: Profiles.PERSONAL,
          elements: {}
        },
        configSubView: {
          module_id: Modules.PEDIDOS,
          profile_id: Profiles.PERSONAL,
          elements: {
            order: true,
            order_sellers: true,
            order_courses: true,
            order_reason: true,
            configuration: true,
            mobile_order_create: true,
            php_custom: true,
          }
        },            
        parameters: {
          haveReason: Helper.hasParametersAccess(Param.P54),
        },        
        primaryColor: '',
        arr: {
          PHPCustom: []
        },        
        modulesActive: [],        
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      this.initDashboardWidgets()

      
      /* Configurar permisos de las sub vistas */
      this.configSubView.elements.order = Helper.showAccessView(this.configSubView, 'crudOrders')      
      this.configSubView.elements.order_sellers = Helper.showAccessView(this.configSubView, 'crudOrdersSeller')      
      this.configSubView.elements.order_courses = Helper.showAccessView(this.configSubView, 'crudOrdersCourses')      
      this.configSubView.elements.order_reason = Helper.showAccessView(this.configSubView, 'crudOrdersReason')      
      this.configSubView.elements.configuration = Helper.showAccessView(this.configSubView, 'configuration')      
      this.configSubView.elements.mobile_order_create = Helper.showAccessView(this.configSubView, 'mobileOrderCreate')
      this.configSubView.elements.php_custom = Helper.showAccessPHPCustom()
      /* Fin configuracion */                    
    },
    mounted() {
      this.modulesActive = Session.getSession().auth.user.permissions.modules

      this.setup()
      this.getPHPCustom()
    }, 
    computed: {
      isSeller(){
        if(Helper.getSeller()) {
          return true
        } else {
          return false
        }
      },

      isProducts() {
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.PRODUCTOS) {
            status = true
          }
        })
        return status
      },
      isCourses() {
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.CURSOS) {
            status = true
          }
        })
        return status
      }
    },     
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      
      openOrders() {
        this.$router.push({ name: 'OrdersStaffCrudOrders' })
      },

      openOrderCourses() {
        this.$router.push({ name: 'OrdersStaffCrudOrdersCourses' })
      },

      openConfiguration() {
        this.$router.push({ name: 'OrdersStaffConfiguration' })
      },    
      
      openOrdersSellers() {
        this.$router.push({ name: 'OrdersStaffCrudOrdersSellers' })
      },

      openMobileOrderCreate() {
        this.$router.push({ name: 'OrdersStaffMobileOrderCreate' })
      },

      openOrdersReason() {
        this.$router.push({ name: 'OrdersStaffReason' })
      },

      getPHPCustom() {
        ServicesPHP.obtenerPHPByModule(Modules.PEDIDOS)
        .then((response) => {
          this.arr.PHPCustom = response.data       
        })
      },
      openPHPCustom(item) {
        this.$router.push({ name: 'ViewStaffViewPHPCustom', params: {id: item.id} })
      }      
    }    
   
  }
</script>

<style>

</style>
